import { render, staticRenderFns } from "./ProjectValuationExternalReportPage9.vue?vue&type=template&id=3d5be1b8&scoped=true&"
import script from "./ProjectValuationExternalReportPage9.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationExternalReportPage9.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectValuationExternalReportPage9.vue?vue&type=style&index=0&id=3d5be1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5be1b8",
  null
  
)

export default component.exports